import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { RiAlertLine, RiCloseLine, RiArrowRightLine } from 'react-icons/ri';
import { useCredits, LOW_CREDIT_THRESHOLD } from '../../context/CreditContext';

export default function LowCreditBanner() {
    const { credits, loading, openPaywall } = useCredits();
    const [dismissed, setDismissed]         = useState(false);

    const show = !loading && !dismissed && credits > 0 && credits <= LOW_CREDIT_THRESHOLD;

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: 'auto' }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.25 }}
                    className="overflow-hidden"
                >
                    <div className="mx-6 mt-4 mb-0 px-4 py-2.5 rounded-xl bg-yellow-500/[0.08] border border-yellow-500/[0.2] flex items-center gap-3">
                        <RiAlertLine className="text-yellow-400 flex-shrink-0" size={16} />
                        <p className="flex-1 text-yellow-300/80 text-sm">
                            <span className="font-semibold text-yellow-300">{credits} credits remaining.</span>
                            {' '}Top up to keep using AI interviews and resume generation.
                        </p>
                        <button
                            onClick={openPaywall}
                            className="flex items-center gap-1 text-yellow-300 text-xs font-semibold whitespace-nowrap hover:text-yellow-200 transition-colors"
                        >
                            Top up <RiArrowRightLine size={13} />
                        </button>
                        <button
                            onClick={() => setDismissed(true)}
                            className="text-yellow-400/40 hover:text-yellow-400 transition-colors flex-shrink-0"
                        >
                            <RiCloseLine size={16} />
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
